import { Location } from '../../../types/models/Location.model'
import { UNITED_KINGDOM } from '../constants'
import { getAllLocationTitles } from '../../../domain/location'

export const isLocationInUnitedKingdom = (location: Location): boolean => {
  const lowercaseUnitedKingdom = UNITED_KINGDOM.toLowerCase()
  return getAllLocationTitles(location)
    .map((locationTitle) => locationTitle.toLowerCase())
    .join(' ')
    .includes(lowercaseUnitedKingdom)
}
